import { motion } from "framer-motion";
import { INDUSTRIES } from "../../lib/content";

export default function Industries() {
  return (
    <section className="relative py-24 md:py-36 border-t border-white/5" data-testid="industries-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="tag-glass"><span className="dot" /> Industries</div>
            <h2 className="font-display text-white text-4xl md:text-6xl leading-[1.02] tracking-tight mt-6">
              Trusted by <span className="italic-accent text-grad-crimson">category-defining</span> brands.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="text-white/72 text-lg leading-relaxed">
              Seventeen industries, one operating principle: earn attention, then compound it.
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap gap-3">
          {INDUSTRIES.map((label, i) => (
            <motion.span
              key={label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.02 }}
              className="rounded-full border border-white/10 px-5 py-3 text-white/80 text-sm hover:border-[#e63946] hover:text-white transition-colors"
              data-testid={`industry-tag-${label.toLowerCase()}`}
            >
              {label}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
